import { Component, OnDestroy} from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Params, ParamMap } from "@angular/router";
import { NavigationStateService } from '../../navigation/navigation.state.service';

@Component({
  moduleId: module.id,
  templateUrl: 'documents.single.component.html',
  providers: []
})

export class DocumentsSingleComponent implements OnDestroy  {

  model: any = {};
  errorMessage: string;

  constructor(private route: ActivatedRoute, private navigationStateService: NavigationStateService, private location: Location) {
  }

  ngOnInit() {
    this.navigationStateService.triggerNavigationStatus({status: false});
  }

  goBack($event) {
    $event.preventDefault();
    this.location.back();
  }

  ngOnDestroy() {
    this.navigationStateService.triggerNavigationStatus({status: true});
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/documents/single/documents.single.component.ts